import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Constant } from '../../infrastructure/constant';
import { DeliveryShipmentToPartnerComponent } from './delivery-shipment-to-partner/delivery-shipment-to-partner.component';
import { ListShipmentToPartnerComponent } from './list-shipment-to-partner/list-shipment-to-partner.component';

const routes: Routes = [
  { path: Constant.pages.shipmentPartnerManagement.children.deliveryShipmentToPartner.alias, component: DeliveryShipmentToPartnerComponent },
  { path: Constant.pages.shipmentPartnerManagement.children.listShipmentToPartner.alias, component: ListShipmentToPartnerComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShipmentPartnerManagementRoutingModule { }
